export const CHECKBOX_VALUES = {
    CHECKED: 'CHECKED',
    UNCHECKED: 'UNCHECKED',
    INDETERMINATE: 'INDETERMINATE'
};
